import { createContext, useContext, useEffect, useState } from "react"

import { isEqual } from "lodash"

import { useCraftProp } from "@/components/builder/utils"

const PaletteContext = createContext()

export const PaletteProvider = ({ children, name, value, onChange }) => {
  const [palette, setPalette] = useState({ rightClick: {}, hover: {} })
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [selectedColor, setSelectedColor] = useState()

  const { value: craftValue, setValue: setCraftValue } = useCraftProp(name)

  const handleCloseContextMenu = () => {
    setPalette({ ...palette, rightClick: {}, hover: {} })
  }

  const handleChangePalette = newPalette => {
    setPalette(prevState => ({ ...prevState, ...newPalette }))
  }

  useEffect(() => {
    if (selectedColor === undefined) {
      setSelectedColor(name ? craftValue : value)
    }
  }, [craftValue, name, selectedColor, value])

  const handleChangeSelectedColor = newSelectedColor => {
    newSelectedColor = newSelectedColor?.name || newSelectedColor
    const newColor = isEqual(newSelectedColor, selectedColor) ? {} : newSelectedColor
    name ? setCraftValue(newColor) : onChange(newColor)
    setSelectedColor(newColor)
  }

  return <PaletteContext.Provider value={{
    palette,
    onChangePalette: handleChangePalette,
    onCloseContextMenu: handleCloseContextMenu,
    tooltipOpen,
    onChangeTooltipOpen: setTooltipOpen,
    selectedColor,
    onChangeSelectedColor: handleChangeSelectedColor,
  }}>
    {children}
  </PaletteContext.Provider>
}

export const usePalette = () => useContext(PaletteContext)
